// extracted by mini-css-extract-plugin
export default {"wrapper":"styles_wrapper__Xv7CS","contentWrapper":"styles_contentWrapper__mTRH7"};